import ShareIcon from '@/assets/svg/icons/share';
import { Button } from '@/components/Button';
import { WrappedPosition } from '@/entities/WrappedPosition';
import { usePnlShareModal } from '@/features/global/hooks';
import { useTradeStore } from '@/features/trade/store';
import classNames from 'classnames';
import { FC } from 'react';
import './index.less';

interface SharePnlButtonProps {
  className?: string;
  position?: WrappedPosition;
}

const SharePnlButton: FC<SharePnlButtonProps> = ({ className, position }) => {
  const { togglePnlShareModal, isOpenModal } = usePnlShareModal();
  const { setSharePnlPosition } = useTradeStore();

  return (
    <Button
      className={classNames('syn-share-pnl-button', className, isOpenModal && 'syn-btn-active syn-icon')}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        !!position && setSharePnlPosition(position);
        togglePnlShareModal(true);
      }}>
      <ShareIcon />
    </Button>
  );
};

export default SharePnlButton;
